/* ILEV · Barra de compra flotante.

   Un IntersectionObserver sobre el formulario de compra de la ficha.
   Sin listener de scroll: el rootMargin ya da la holgura que evita el
   temblor que tenia el prototipo.
   (2026-09-23: reemplazado por una revision en scroll, ver init().)

   2026-09-09 · paso de cantidad, pista de envio, y dos cosas para que
   el chat no tape el boton: una clase en <html> y el alto real de la
   barra publicado en la variable --ilev-bb-alto. El CSS corre la
   burbuja justo esa distancia; si se usara un numero fijo, en celular
   quedaria corto o largo, porque la barra no siempre mide lo mismo.

   REGLA QUE NO HAY QUE ROMPER: la barra nunca arma su propio
   formulario. Escribe en el input `quantity` del formulario que ya
   existe en la pagina y despues aprieta su boton. Armar un formulario
   aparte es lo que rompe el carrito.

   2026-09-10 · La escalera por producto ya no viene de una app: la
   dibuja el tema (snippets/ilev-escalera.liquid) y la aplica Shopify con
   descuentos nativos. Por eso la barra ahora si puede mostrar el precio
   real y el tachado: lee window.ILEV_ESCALERA
   cuando existe. Si no existe, se comporta exactamente como antes.
   Respaldo del original: assets/respaldo-ilev-buybar-marli-2026-09-10.js */
(function () {
  'use strict';

  /* CLP no usa decimales y Shopify guarda el monto en centavos.
     Si algun dia la tienda vende en otra moneda, revisar esto. */
  function plata(centavos) {
    var pesos = Math.round(centavos / 100);
    try {
      return '$' + pesos.toLocaleString('es-CL');
    } catch (e) {
      return '$' + pesos;
    }
  }

  function num(valor, porDefecto) {
    var n = parseInt(valor, 10);
    return isNaN(n) ? porDefecto : n;
  }

  function init() {
    var bar = document.querySelector('[data-ilev-buybar]');
    if (!bar) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    bar.hidden = false;

    var raiz = document.documentElement;

    /* El alto real de la barra, para que el chat se corra lo justo. */
    function medirAlto() {
      var alto = Math.round(bar.getBoundingClientRect().height);
      if (alto > 0) raiz.style.setProperty('--ilev-bb-alto', alto + 'px');
    }

    function marcar(visible) {
      bar.classList.toggle('is-on', visible);
      raiz.classList.toggle('ilev-bb-on', visible);
      if (visible) medirAlto();
    }

    medirAlto();

    /* 2026-09-23 (Franco): la barra aparece solo cuando el boton principal
       ya quedo ATRAS, arriba de la pantalla. Antes salia cada vez que el
       boton no estaba en pantalla, tambien cuando seguia ABAJO sin haberlo
       alcanzado: en celular el boton cae a ~1.370 px y la barra salia al
       cargar la ficha. Hipotesis: sin la barra al inicio, la gente baja mas.

       Se cambio el IntersectionObserver por una revision en scroll (pasiva,
       una vez por cuadro). El observer solo avisa cuando el boton entra o
       sale de pantalla: si la persona salta de "boton abajo" a "boton
       arriba" sin verlo (vuelve atras y el navegador le restaura el scroll,
       o toca un link a las resenas) nunca avisaba y la barra no salia.
       La barra es fija: aparecer no mueve el boton, asi que no hay temblor.

       Ojo medicion: desde este cambio ver_buybar = paso el boton principal
       (antes = casi todos al cargar). */
    var visible = null;
    function revisar() {
      var pasado = form.getBoundingClientRect().bottom < 80;
      if (pasado !== visible) { visible = pasado; marcar(pasado); }
    }
    var pedido = false;
    window.addEventListener('scroll', function () {
      if (pedido) return;
      pedido = true;
      requestAnimationFrame(function () { pedido = false; revisar(); });
    }, { passive: true });
    revisar();

    var tRedim;
    window.addEventListener('resize', function () {
      clearTimeout(tRedim);
      tRedim = setTimeout(function () { medirAlto(); revisar(); }, 180);
    }, { passive: true });

    /* ---- datos ---- */
    var precio = num(bar.getAttribute('data-precio'), 0);
    var umbral = num(bar.getAttribute('data-umbral'), 0);
    var maximo = num(bar.getAttribute('data-max'), 6);
    var txtListo = bar.getAttribute('data-envio-listo') || '';
    var txtFalta = bar.getAttribute('data-envio-falta') || '';
    var txtLejos = bar.getAttribute('data-envio-lejos') || '';
    /* 11-sep-2026 (Franco): la barra tambien empuja al siguiente escalon de
       descuento, no solo al envio gratis. Los porcentajes salen de la escalera
       del producto (window.ILEV_ESCALERA: t2 = 2 u., t3 = 3 u.), asi que cada
       ficha muestra el suyo (DUO 10/20 %, Tonico y Bomba 10/15 %). En packs y
       regalos, que no tienen escalera, todo queda como antes. */
    var notaEl = bar.querySelector('[data-bb-note]');
    var txtNota = bar.getAttribute('data-nota') || '';
    var txtNotaEnvio = bar.getAttribute('data-nota-envio') || '';
    var txtSube = bar.getAttribute('data-pista-sube') || '';
    var txtTope = bar.getAttribute('data-pista-tope') || '';

    /* 2026-09-10 · Si la ficha tiene la escalera por producto (selector de
       bundles), la barra le pregunta a ella el precio real y cuántas
       unidades van gratis. Si no existe (packs, regalos), todo sigue igual
       que antes: precio de lista x cantidad. */
    var E = (window.ILEV_ESCALERA && typeof window.ILEV_ESCALERA.precio === 'function') ? window.ILEV_ESCALERA : null;
    if (E && E.umbralEnvio) umbral = E.umbralEnvio;

    var total = bar.querySelector('[data-bb-total]');
    var tachado = bar.querySelector('[data-bb-was]');
    if (E && total && !tachado) {
      tachado = document.createElement('s');
      tachado.className = 'ilev-bb__was';
      tachado.setAttribute('data-bb-was', '');
      tachado.hidden = true;
      total.parentNode.insertBefore(tachado, total.nextSibling);
    }
    function pagado(n) { return E ? E.precio(n) : precio * n; }
    var pista = bar.querySelector('[data-bb-pista]');
    var menos = bar.querySelector('[data-bb-menos]');
    var mas = bar.querySelector('[data-bb-mas]');
    var cuenta = bar.querySelector('[data-bb-cant]');
    var campo = form.querySelector('[name="quantity"]');

    var cant = 1;

    /* Cuantas unidades hacen falta para pasar el umbral de envio
       (con el precio realmente pagado, escalera incluida). */
    function unidadesParaEnvio() {
      if (!precio || !umbral) return 0;
      var n = 1;
      while (n < 12 && pagado(n) < umbral) n++;
      return n;
    }

    /* "30 dias mas" / "1 unidad mas", segun como se venda el producto */
    function cuanto(n) {
      if (E && E.modo === 'dias') return (n * 30) + ' días';
      return n === 1 ? '1 unidad' : n + ' unidades';
    }
    /* % de descuento que aplica al llevar n unidades */
    function offDe(n) {
      if (!E) return 0;
      if (n >= 3) return E.t3 || 0;
      if (n === 2) return E.t2 || 0;
      return 0;
    }

    function pintarPista() {
      var conEnvio = umbral > 0 && precio > 0 && pagado(cant) >= umbral;

      /* la nota del precio avisa el envio gratis cuando ya esta ganado */
      if (notaEl && txtNota) {
        notaEl.textContent = (conEnvio && txtNotaEnvio) ? txtNotaEnvio : txtNota;
      }

      if (!pista) return;
      var texto = '';

      /* 11-sep-2026 (2): se ofrece EL HITO MAS CERCANO, no siempre el envio.
         En el DUO los dos caen en 2 unidades; en el Tonico el envio gratis
         recien llega a la 4.a, y el escalon de descuento esta a 1: sin esto,
         la barra repetia "Llevando 4..." con 1, 2 y 3 unidades.
         Si los dos hitos empatan, gana el de envio, que ya muestra el %. */
      var nEnvio = (umbral > 0 && precio > 0) ? unidadesParaEnvio() : 0;
      var faltaEnvio = (!conEnvio && nEnvio > 1 && nEnvio <= 4 && nEnvio <= maximo) ? (nEnvio - cant) : 0;

      var sigEscalon = 0, offSig = 0;
      if (E) {
        if (cant < 2 && (E.t2 || 0) > 0) { sigEscalon = 2; offSig = E.t2; }
        else if (cant < 3 && (E.t3 || 0) > 0) { sigEscalon = 3; offSig = E.t3; }
      }
      var faltaEscalon = (sigEscalon && sigEscalon <= maximo) ? (sigEscalon - cant) : 0;

      if (faltaEscalon > 0 && txtSube && (faltaEnvio === 0 || faltaEscalon < faltaEnvio)) {
        texto = txtSube.replace('{falta}', cuanto(faltaEscalon)).replace('{off}', offSig);
      } else if (faltaEnvio > 0 && txtFalta) {
        texto = txtFalta.replace('{n}', nEnvio);
        var off = offDe(nEnvio);
        if (off > 0) texto += ' + ' + off + '% OFF';
      } else if (conEnvio) {
        if (E && cant >= 3 && (E.t3 || 0) > 0 && txtTope) texto = txtTope.replace('{off}', E.t3);
        else texto = txtListo;
      } else if (umbral > 0 && precio > 0) {
        texto = txtLejos;
      }

      if (texto) {
        pista.textContent = texto;
        pista.hidden = false;
      } else {
        pista.textContent = '';
        pista.hidden = true;
      }
      /* La pista puede aparecer o desaparecer, y con eso cambia el alto
         de la barra: hay que volver a publicarlo. */
      medirAlto();
    }

    function pintarPrecio() {
      if (!total || !(precio > 0)) return;
      total.textContent = plata(pagado(cant));
      if (tachado) {
        var lista = precio * cant;
        if (pagado(cant) < lista) { tachado.textContent = plata(lista); tachado.hidden = false; }
        else { tachado.hidden = true; }
      }
    }

    function pintar() {
      if (cuenta) cuenta.textContent = cant;
      pintarPrecio();
      if (campo) campo.value = cant;
      if (menos) menos.disabled = cant <= 1;
      if (mas) mas.disabled = cant >= maximo;
      pintarPista();
    }

    function cambiar(paso) {
      var nuevo = cant + paso;
      if (nuevo < 1) nuevo = 1;
      if (nuevo > maximo) nuevo = maximo;
      if (nuevo === cant) return;
      cant = nuevo;
      pintar();
      /* avisa al selector de bundles para que marque la misma opcion */
      document.dispatchEvent(new CustomEvent('ilev:cantidad', { detail: { n: cant, origen: 'buybar' } }));
    }

    /* el selector de bundles eligio una cantidad: la barra la sigue */
    document.addEventListener('ilev:cantidad', function (e) {
      if (!e.detail || e.detail.origen === 'buybar') return;
      var n = num(e.detail.n, 1);
      if (n < 1) n = 1;
      if (n > maximo) n = maximo;
      cant = n;
      if (cuenta) cuenta.textContent = cant;
      pintarPrecio();
      if (menos) menos.disabled = cant <= 1;
      if (mas) mas.disabled = cant >= maximo;
      pintarPista();
    });

    if (menos) menos.addEventListener('click', function () { cambiar(-1); });
    if (mas) mas.addEventListener('click', function () { cambiar(1); });

    /* Si la persona cambia la cantidad en la ficha, la barra la sigue. */
    if (campo) {
      campo.addEventListener('change', function () {
        var n = num(campo.value, 1);
        if (n < 1) n = 1;
        if (n > maximo) n = maximo;
        cant = n;
        if (cuenta) cuenta.textContent = cant;
        pintarPrecio();
        if (menos) menos.disabled = cant <= 1;
        if (mas) mas.disabled = cant >= maximo;
        pintarPista();
      });
    }

    pintar();

    /* ---- el boton ---- */
    var cta = bar.querySelector('[data-ilev-buybar-cta]');
    if (!cta) return;
    cta.addEventListener('click', function () {
      if (campo) campo.value = cant;
      /* Enviamos el formulario que ya existe en la pagina.
         No construimos uno nuevo: eso es lo que rompe el carrito. */
      var boton = form.querySelector('[type="submit"], [name="add"]');
      if (boton) { boton.click(); return; }
      if (typeof form.requestSubmit === 'function') { form.requestSubmit(); }
      else { form.submit(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
